module.exports = __webpack_public_path__ + "img/bird-man.7232ae8b.png";